import React from 'react';
import './coaText.css';
import { Link } from 'react-router-dom';



export default function ButtonE2(){
    return (
        <div className="TextCenter">
             <Link className="TextDecoration" to="/Contato"><button className="coaText" href="Catalago">
                Contato: (67) 3022-6200 <ul/> Rua Albert Sabin, 2094 - Vila Taveiropolis, Campo Grande - MS | CEP 79090-160
             </button></Link>
        </div>
    )
}